import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, TokenStore, LoginRes } from '@models/User';

interface AuthState extends TokenStore {
  tokenExpires: BigInt | null;
  user: User | null;
  apiversion: string | '';
}

const initialState: AuthState = {
  accessToken: '',
  refreshToken: '',
  tokenExpires: null,
  user: null,
  apiversion: '',
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthState(state, action: PayloadAction<LoginRes>){
      const { token, refreshToken, tokenExpires, user, apiVersion } = action.payload;
      state.accessToken = token;
      state.refreshToken = refreshToken;
      state.tokenExpires = tokenExpires;
      state.user = user;
      state.apiversion = apiVersion;
    },

    clearAuthState(state) {
      state.accessToken = '';
      state.refreshToken = '';
      state.tokenExpires = null;
      state.user = null;
      state.apiversion = '';
    },
  }
});

export const {
  setAuthState,
  clearAuthState
} = authSlice.actions;

export default authSlice.reducer;
